
<div class="page-padding">
  <div class="panel">
      <div class="panel__header">
          <span class="panel__header__title">{{'Make Setup' | translate | async}}</span>        
      </div>

      <div style="margin-left: 25px;"><span style="font-size: 17px; font-weight: bold;">{{'Select Existing Make' | translate | async}}</span></div>     
      <div class="panel__sub-header" style="display: block;">    
           <div class="input-container" style="margin-left: 1%">
            <span class="label" style="min-width: 100px;">{{'Make' | translate | async}}</span>           
              <!-- <mat-form-field  class="header-form-full-width">          
                   <input type="text" placeholder="Select Make"  [(ngModel)]="selectedMakeAutoComplete" (input)="changeMakeAutoComplete($event)"   matInput  [matAutocomplete]="auto">
                 <mat-autocomplete  (optionSelected)="onSelectMake($event.option.value)"  [(ngModel)]="selectedMake" #model_auto="ngModel"  #auto="matAutocomplete" [displayWith]="getTitle.bind(this)"  ngDefaultControl  >
                   <mat-option [value]="make.Id" *ngFor="let make of makeList">
                      {{make.Title}}
                  </mat-option>
                </mat-autocomplete>
             </mat-form-field> -->

             <mat-form-field class="header-form-full-width">
              <mat-select placeholder="{{'Select Make' | translate | async}}" [(ngModel)]="selectedMake" (selectionChange)="onSelectMake($event)">
                <mat-option [value]="make.Id" *ngFor="let make of makeList" >
                  {{make.Title}}
              </mat-option>
              </mat-select>
            </mat-form-field>
            
             
           </div>        
      </div>

      <div style="margin-left: 25px; margin-top: 25px;"><span style="font-size: 17px; font-weight: bold;">{{'Make Details' | translate | async}}</span></div>
      <div class="panel__sub-header" style="display: block;">    
           <div class="input-container" style="margin-left: 1%">
            <span class="label" style="min-width: 100px;">{{'Make ID' | translate | async}}</span>           
                <mat-form-field class="header-form-full-width">       
                  <input type="text" matInput placeholder="{{'Enter Make ID' | translate | async}}" [(ngModel)]="makeSymbol">
                </mat-form-field>        
          </div>         
          <div class="input-container" style="margin-left: 1%">
            <span class="label" style="min-width: 100px;">{{'Make Name' | translate | async}}</span>           
               <mat-form-field class="header-form-full-width">       
                 <input type="text" matInput placeholder="{{'Enter Make Name' | translate | async}}" [(ngModel)]="makeName">
            </mat-form-field>         
         </div> 
      
         <div style="display: flex; gap: 20px; height: 40px; margin: 0 1%;" >
            <mat-checkbox class="example-margin" [(ngModel)]="isCheckedUndercarriage"  (change)="ChangeCheckbox1($event)" >{{'Undercarriage' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="isCheckedComponent"  (change)="ChangeCheckbox2($event)" >{{'Components' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="isCheckedOEM"  (change)="ChangeCheckbox3($event)" >{{'OEM' | translate | async}}</mat-checkbox>
        </div>
     </div>

     <div style="display: flex;flex-direction: row;align-self: flex-end; margin-bottom: 1%; margin-right: 1%;">
       <button style="margin-left: 20px;" class="button button--primary" [disabled]="isHideAdd" (click)="AddnewMake()" ><span
          class="button__text">{{'Add' | translate | async}}</span></button>
       <button  style="margin-left: 20px;" class="button button--primary" [disabled]="isHideUpdate" (click)="UpdateMake_()" ><span class="button__text"
          >{{'Update' | translate | async}}</span></button>
       <button style="margin-left: 20px;" class="button button--primary" [disabled]="isHideDelete" (click)="deleteMake()"><span class="button__text"
          >{{'Delete' | translate | async}}</span></button>
        <button style="margin-left: 20px;" class="button button--primary" (click)="resetFeilds()"><span class="button__text"
          >{{'Reset' | translate | async}}</span></button>
    </div>

    
  </div>
  </div>